export const recentActivities = [
  { id: "act-1", text: "2 matches are currently live.", time: "Now" },
  { id: "act-2", text: "9 streams running across all sports.", time: "Now" },
  { id: "act-3", text: "Latest match added: Mumbai Tigers vs Delhi Knights.", time: "15 min ago" }
];

export const dashboardStats = [
  { title: "Total Users", value: 12450, growth: "+8.2% vs prev 30d", trend: "up" },
  { title: "Total Matches", value: 386, growth: "+5.1% vs prev 30d", trend: "up" },
  { title: "Live Matches", value: 6, growth: "14 upcoming", trend: "up" },
  { title: "Streams Running", value: 9, growth: "18 scheduled", trend: "up" },
  { title: "Live Channels", value: 4, growth: "12 total", trend: "up" }
];

export const dashboardLine = [
  { name: "Nov", users: 1180, matches: 42 },
  { name: "Dec", users: 1240, matches: 48 },
  { name: "Jan", users: 1335, matches: 54 },
  { name: "Feb", users: 1410, matches: 50 },
  { name: "Mar", users: 1525, matches: 61 },
  { name: "Apr", users: 1605, matches: 67 }
];

export const sportsDistribution = [
  { sport: "Cricket", matches: 122 },
  { sport: "Football", matches: 96 },
  { sport: "Kabaddi", matches: 58 },
  { sport: "Tennis", matches: 44 }
];

export const latestMatches = [
  { id: "M-A91F2B", teams: "Mumbai Tigers vs Delhi Knights", sport: "Cricket", status: "live", viewers: 18420 },
  { id: "M-C71D83", teams: "Bengal Blazers vs Pune Hawks", sport: "Football", status: "upcoming", viewers: 0 },
  { id: "M-3EB6A0", teams: "Hyd Panthers vs Chennai Chargers", sport: "Kabaddi", status: "completed", viewers: 9370 }
];

export const notificationsHistory = [
  { id: "NTF-1001", message: "Tonight's headline match starts at 8 PM.", audience: "All Users", sentAt: "Apr 10, 2026" },
  { id: "NTF-1002", message: "Cricket finals tickets are now live.", audience: "Cricket Fans", sentAt: "Apr 07, 2026" }
];

export const reportCards = [
  { label: "Engagement", value: "68.2%" },
  { label: "Conversion", value: "11.9%" },
  { label: "Avg Session", value: "14m 26s" },
  { label: "Retention", value: "43.7%" }
];

export const reportSeries = [
  { month: "Nov", engagement: 52, conversion: 8 },
  { month: "Dec", engagement: 56, conversion: 9 },
  { month: "Jan", engagement: 59, conversion: 10 },
  { month: "Feb", engagement: 63, conversion: 10.6 },
  { month: "Mar", engagement: 66, conversion: 11.2 },
  { month: "Apr", engagement: 69, conversion: 11.9 }
];

export const sportsCategories = [
  { id: "sport-1", name: "Cricket", total: 142, live: 5, icon: "Trophy" },
  { id: "sport-2", name: "Football", total: 97, live: 2, icon: "Shield" },
  { id: "sport-3", name: "Kabaddi", total: 64, live: 1, icon: "Radio" },
  { id: "sport-4", name: "Tennis", total: 39, live: 1, icon: "Circle" }
];
